import { validate as isUUID } from 'uuid'

/**
 * Verify a given ID is a valid record ID (UUID), mirroring the API's isValidId.
 * Use to validate untrusted ids (e.g. from route params) before they are used
 * to build a request URL.
 *
 * @param id Record ID to test
 * @returns {boolean}
 */
export function isValidId(id: string | null | undefined): id is string {
  return typeof id === 'string' && isUUID(id)
}
